export const LEGACY_POPUPS_PATH = '/legacy-popups';
